import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { usePost } from "redux/fetch-hooks";

import { TextButton } from "common/DS/Buttons";

export function useLogout(checkinHash) {
    const [postLogout] = usePost("/check-in/auth/logout", {
        onSuccess: () => {
            // frontend 301 MOVED PERMANENTLY
            window.history.replaceState({}, "", "/hub");
            window.location.replace("/hub");
        },
        onError: () => {},
    });

    const [logoutCalled, setLogoutCalled] = useState(false);

    const doLogout = (e) => {
        if (e) {
            e.preventDefault();
        }

        setLogoutCalled(true);

        postLogout({
            data: {
                csrf_token: window.csrfToken,
                checkin_hash: checkinHash,
            },
        });
    };

    return [doLogout, logoutCalled];
}

// eslint-disable-next-line no-unused-vars
export default function LogOut({ checkinHash, showCountDown }) {
    const [doLogout, logoutCalled] = useLogout(checkinHash);

    const [countDown, setCountDown] = useState(30);

    useEffect(() => {
        let interval;

        if (showCountDown) {
            interval = setInterval(() => {
                setCountDown((c) => (c > 0 ? c - 1 : 0)); // Numbers have limits
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [showCountDown]);

    useEffect(() => {
        if (!logoutCalled && countDown <= 0) {
            doLogout();
        }
    }, [countDown, logoutCalled]);

    return (
        <div className="check-in__logout">
            {showCountDown && (
                <div className="check-in__logout-text">
                    Auto Logout in {countDown} sec or you can
                </div>
            )}
            <TextButton onClick={doLogout}>Logout</TextButton>
        </div>
    );
}

LogOut.propTypes = {
    checkinHash: PropTypes.string,
    showCountDown: PropTypes.bool,
};

LogOut.defaultProps = {
    checkinHash: null,
    showCountDown: false,
};
